export function rounded(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, color: string): void {
  ctx.fillStyle = color; ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.fill();
}
export function face(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, color: string, kind = 'happy'): void {
  rounded(ctx, x - size / 2, y - size / 2, size, size, size * .28, color);
  ctx.fillStyle = '#172320';
  ctx.fillRect(x - size * .22, y - size * .1, size * .1, size * .12);
  ctx.fillRect(x + size * .12, y - size * .1, size * .1, size * .12);
  ctx.strokeStyle = '#172320'; ctx.lineWidth = Math.max(2, size * .05);
  ctx.beginPath(); ctx.arc(x, y + size * .1, size * .13, kind === 'happy' ? 0 : Math.PI, kind === 'happy' ? Math.PI : Math.PI * 2); ctx.stroke();
}
export function cup(ctx: CanvasRenderingContext2D, x: number, y: number, size: number): void {
  ctx.strokeStyle = '#fff4df'; ctx.lineWidth = size * .12;
  ctx.beginPath(); ctx.arc(x + size * .4, y, size * .2, -Math.PI / 2, Math.PI / 2); ctx.stroke();
  rounded(ctx, x - size * .4, y - size * .3, size * .8, size * .65, size * .18, '#fff4df');
  rounded(ctx, x - size * .33, y - size * .35, size * .66, size * .16, size * .08, '#694536');
  ctx.fillStyle = '#23352e'; ctx.fillRect(x - size * .19, y, size * .08, size * .1); ctx.fillRect(x + size * .12, y, size * .08, size * .1);
  rounded(ctx, x - size * .55, y + size * .4, size * 1.1, size * .1, 3, '#c9f36b');
}

export function colleague(ctx: CanvasRenderingContext2D, x: number, y: number, size: number, role: number, onBreak = false, time = 0): void {
  ctx.save(); ctx.translate(x, y); ctx.scale(size / 30, size / 30);
  const bounce = Math.sin(time * 10 + role * 2) * .7;
  ctx.translate(0, bounce);
  const suit = onBreak ? '#6b92b5' : ['#dd8197', '#aa91de', '#6dafba'][role];
  // Shoes, sleeves and a shirt make the silhouette human even at one maze cell.
  rounded(ctx, -7, 9, 6, 5, 2, '#182723'); rounded(ctx, 2, 9, 6, 5, 2, '#182723');
  rounded(ctx, -11, 0, 22, 8, 4, suit); rounded(ctx, -8, -2, 16, 14, 3, suit);
  rounded(ctx, -2, -4, 4, 5, 1, '#e9b695');
  rounded(ctx, -7, -14, 14, 13, 5, ['#edbd9b', '#c58f6a', '#f1cbb1'][role]);
  rounded(ctx, -7, -15, 14, 4, 2, role === 1 ? '#543b2a' : '#34383e');
  if (role === 1) { ctx.fillStyle = '#543b2a'; ctx.beginPath(); ctx.arc(7, -13, 3, 0, Math.PI * 2); ctx.fill(); }
  ctx.fillStyle = '#243029'; ctx.fillRect(-4, -9, 2, 2); ctx.fillRect(2, -9, 2, 2);
  ctx.strokeStyle = '#6d4939'; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(-2, -4); ctx.lineTo(2, -4); ctx.stroke();
  if (role === 0) {
    ctx.fillStyle = '#f8efda'; ctx.beginPath(); ctx.moveTo(-4, -1); ctx.lineTo(4, -1); ctx.lineTo(0, 4); ctx.fill();
    rounded(ctx, -1, 1, 2, 7, 1, '#47374b'); rounded(ctx, 8, 5, 6, 7, 1, '#6a4e35');
  } else if (role === 1) {
    rounded(ctx, 3, 1, 9, 10, 1, '#fff1d6'); rounded(ctx, 5, 0, 5, 2, 1, '#62594a');
    ctx.fillStyle = '#756650'; ctx.fillRect(5, 4, 5, 1); ctx.fillRect(5, 7, 4, 1);
  } else {
    ctx.strokeStyle = '#26343d'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(0, -9, 8, Math.PI, Math.PI * 2); ctx.stroke();
    rounded(ctx, -9, -10, 3, 5, 1, '#26343d'); rounded(ctx, 6, -10, 3, 5, 1, '#26343d');
    ctx.beginPath(); ctx.moveTo(8, -7); ctx.lineTo(4, -4); ctx.stroke();
    rounded(ctx, -5, 3, 10, 7, 1, '#26343d'); rounded(ctx, -4, 4, 8, 4, 1, '#a4dcdf');
  }
  if (onBreak) {
    rounded(ctx, -13, -19, 11, 8, 3, '#d5fa86');
    ctx.fillStyle = '#273b25'; ctx.font = 'bold 7px monospace'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('Z', -7.5, -15);
  }
  ctx.restore();
}
export function preview(canvas: HTMLCanvasElement, id: string): void {
  canvas.width = 600; canvas.height = 300;
  const c = canvas.getContext('2d')!;
  c.fillStyle = id === 'espresso' ? '#302a48' : id === 'office' ? '#393025' : id === 'animals' ? '#254031' : '#25352b';
  c.fillRect(0, 0, 600, 300);
  c.strokeStyle = '#ffffff07'; c.lineWidth = 1;
  for (let x = 0; x < 600; x += 30) { c.beginPath(); c.moveTo(x, 0); c.lineTo(x, 300); c.stroke(); }
  for (let y = 0; y < 300; y += 30) { c.beginPath(); c.moveTo(0, y); c.lineTo(600, y); c.stroke(); }
  if (id === 'espresso') {
    for (let row = 0; row < 2; row++) for (let col = 0; col < 5; col++) {
      const x = 170 + col * 66, y = 55 + row * 57;
      face(c, x, y, 35, row ? '#bba7fa' : '#f2c280', 'angry');
      if (!row) { c.fillStyle = '#fff4df'; c.fillRect(x - 10, y - 26, 20, 5); }
    }
    cup(c, 300, 243, 57);
    for (const y of [161, 199]) rounded(c, 298, y, 5, 17, 2, '#c9f36b');
    c.font = 'bold 12px monospace'; c.fillStyle = '#bba7fa'; c.fillText('INBOX: 999+', 34, 264);
  } else if (id === 'snake') {
    const path = [[180, 180], [220, 180], [260, 180], [300, 180], [300, 140], [300, 100], [340, 100], [380, 100]];
    path.forEach(([x, y], i) => rounded(c, x - 18, y - 18, 36, 36, 10, i === 7 ? '#e6ffae' : '#98bd55'));
    face(c, 380, 100, 37, '#c9f36b');
    c.font = '36px sans-serif'; c.fillText('🫒', 432, 111); c.fillText('🌶️', 112, 122); c.fillText('🍋', 406, 220);
    c.font = 'bold 12px monospace'; c.fillStyle = '#c9f36b'; c.fillText('CONTO: € 42,00', 34, 264);
  } else if (id === 'office') {
    c.strokeStyle = '#75624a'; c.lineWidth = 12; c.lineJoin = 'round';
    c.strokeRect(110, 30, 380, 230);
    for (const x of [165, 300, 435]) { c.strokeRect(x, 75, 55, 40); c.strokeRect(x, 190, 55, 30); }
    for (let x = 150; x < 490; x += 28) { c.fillStyle = '#f8ce8c'; c.beginPath(); c.arc(x, 151, 4, 0, Math.PI * 2); c.fill(); }
    face(c, 223, 151, 38, '#ffd17f');
    colleague(c, 352, 151, 42, 0); colleague(c, 409, 151, 42, 1); colleague(c, 463, 151, 42, 2);
    cup(c, 142, 230, 30); c.font = 'bold 13px monospace'; c.fillStyle = '#f2a5ae'; c.fillText('HAI UN MINUTO?', 307, 65);
  } else if (id === 'globe') {
    c.save(); c.translate(300, 150);
    c.shadowColor = '#72c5ad'; c.shadowBlur = 55;
    c.fillStyle = '#6eb9a5'; c.beginPath(); c.arc(0, 0, 104, 0, 7); c.fill(); c.shadowBlur = 0;
    c.save(); c.beginPath(); c.arc(0, 0, 104, 0, 7); c.clip();
    c.fillStyle = '#caeab4'; c.beginPath(); c.moveTo(-72, -90); c.lineTo(-20, -75); c.lineTo(-12, -42); c.lineTo(29, -25); c.lineTo(13, 6); c.lineTo(-30, -3); c.lineTo(-42, 36); c.lineTo(-73, 0); c.closePath(); c.fill();
    c.beginPath(); c.moveTo(26, 10); c.lineTo(66, 25); c.lineTo(58, 75); c.lineTo(27, 107); c.lineTo(9, 63); c.closePath(); c.fill();
    c.fillStyle = '#fff3c8'; c.beginPath(); c.moveTo(78, -80); c.lineTo(113, -60); c.lineTo(97, -10); c.lineTo(55, -37); c.closePath(); c.fill();
    c.strokeStyle = '#183e3825'; c.lineWidth = 1.5;
    for (const r of [36, 72, 104]) { c.beginPath(); c.ellipse(0, 0, r, 104, 0, 0, 7); c.stroke(); }
    for (const y of [-52, 0, 52]) { c.beginPath(); c.ellipse(0, y, 104, 18, 0, 0, 7); c.stroke(); }
    c.restore(); c.restore();
    rounded(c, 365, 194, 98, 31, 15, '#f1e9d4'); c.fillStyle = '#24372e'; c.font = 'bold 13px monospace'; c.fillText('↗ 420 km', 377, 215);
  } else {
    // A suspiciously calm animal detective, drawn natively rather than downloaded.
    rounded(c, 224, 68, 54, 78, 27, '#edbf7a'); rounded(c, 322, 68, 54, 78, 27, '#edbf7a');
    rounded(c, 240, 81, 24, 46, 12, '#b7785e'); rounded(c, 336, 81, 24, 46, 12, '#b7785e');
    face(c, 300, 158, 145, '#edbf7a'); rounded(c, 273, 162, 54, 49, 24, '#fff0cf');
    c.fillStyle = '#293a30'; c.beginPath(); c.moveTo(291, 165); c.lineTo(309, 165); c.lineTo(300, 177); c.fill();
    c.strokeStyle = '#c9f36b'; c.lineWidth = 9; c.beginPath(); c.arc(399, 198, 31, 0, 7); c.stroke(); c.beginPath(); c.moveTo(421, 222); c.lineTo(448, 249); c.stroke();
    c.fillStyle = '#c9f36b'; c.font = 'bold 35px monospace'; c.fillText('?', 145, 112); c.font = 'bold 23px monospace'; c.fillText('?', 415, 80);
  }
}
